/* Muted inline autoplay, including videos revealed by the product gallery. */
(()=>{
 const configured=new WeakSet();
 const isHidden=video=>video.hidden||Boolean(video.closest('dialog:not([open]),[hidden]'));
 function start(video){
  if(isHidden(video)){video.pause();return}
  const attempt=video.play();
  if(attempt?.catch)attempt.catch(()=>{video.controls=true});
 }
 function configure(video){
  if(configured.has(video))return;
  configured.add(video);
  video.defaultMuted=true;video.muted=true;video.autoplay=true;video.loop=true;video.playsInline=true;
  video.controls=true;video.preload='auto';
  ['autoplay','muted','loop','playsinline','controls'].forEach(name=>video.setAttribute(name,''));
  start(video);
 }
 function scan(root){
  if(root instanceof HTMLVideoElement)configure(root);
  root.querySelectorAll?.('video').forEach(configure);
 }
 scan(document);
 new MutationObserver(changes=>{
  changes.forEach(change=>{
   if(change.type==='childList')change.addedNodes.forEach(scan);
   else if(change.target instanceof HTMLVideoElement)start(change.target);
  });
 }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
})();
